import Colors from '../../common/color';
import UserHeader from '../../components/user/Header'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { examQuestionSkillService } from '../../services/examQuestionSkill';
import NotFound from '../../components/user/NotFound';

interface ExamInforProps {
    type: string;
}

const ExamInfor: React.FC<ExamInforProps> = ({ type }) => {
    const { id } = useParams();
    const location = useLocation();

    const [examQuestionSkill, setexamQuestionSkill] = useState<any>(null);
    const [skill, setSkill] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            if (type === 'public') {
                try {
                    const decodedId = atob(id);
                    const response: any = await examQuestionSkillService.findExamQuestionById(decodedId);
                    setexamQuestionSkill(response);
                    setSkill(response?.Skill);
                    setIsLoading(false);
                } catch (error) {
                    setIsLoading(false);
                    return
                }
            } else if (type === 'private') {
                let examQuestionSkill = location?.state?.examQuestionSkill;
                setexamQuestionSkill(examQuestionSkill);
                let skill = location?.state?.examQuestionSkill?.Skill;
                setSkill(skill);
                setIsLoading(false);
            }
        };
        fetchData();
    }, [id, location, type]);

    return (
        isLoading ?
            <div className="w-full h-screen flex justify-center items-center">
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
            </div> :
            skill ?
                <>
                    {type === 'private' && <UserHeader />}
                    <div className='w-full pr-4 pl-4'>
                        <div className='p-6 space-y-4 mt-[120px] mx-auto max-w-2xl font-medium'>
                            <p className="text-[13px]">Aptis General Practice Test</p>
                            <p className="text-[15.7px]">{skill?.name}</p>
                            <div className='flex flex-row justify-between w-[40%] text-[10.5px]'>
                                <div className='flex flex-col'>
                                    <p className='mb-1'>Number of Questions:</p>
                                    <p className='text-[12.25px] font-bold'>{skill?.numberOfQuestion}</p>
                                </div>
                                <div className='flex flex-col'>
                                    <p className='mb-1'>Time Allowed:</p>
                                    <p className='text-[12.25px] font-bold'>{skill?.timeAllow} min</p>
                                </div>
                            </div>
                            <p className='text-[12px] font-bold'>Assessment Description: </p>
                            <p className='text-[12px] font-bold' dangerouslySetInnerHTML={{
                                __html: skill?.assessmentDescription?.replace(/\n/g, '<br />') || ''
                            }}></p>

                            {
                                type === 'private' && <div>
                                    <p className='text-[12px] font-bold'>Form Description: </p>
                                    <p className='text-[12px] font-bold' dangerouslySetInnerHTML={{
                                        __html: skill?.formDescription?.replace(/\n/g, '<br />') || ''
                                    }}></p>
                                </div>

                            }
                            <Link to={type === 'public' ? `/practice-test` : type === 'private' ? `/exam` : ``}
                                state={{ examQuestionSkill: examQuestionSkill }}>
                                <div className='mt-4 p-2 text-white text-center rounded' style={{
                                    backgroundColor: Colors.primary,
                                    width: window.innerWidth < 768 && window.innerWidth > 425 ? '50%' :
                                        window.innerWidth < 425 ? '100%' : '25%'
                                }}>
                                    Start Assessment
                                </div>
                            </Link>
                        </div>
                    </div>
                </> : <NotFound />
    );
}

export default ExamInfor
